export default __webpack_public_path__ + "static/media/mane.e1e65b5d.png";